import { render, staticRenderFns } from "./wenjian.vue?vue&type=template&id=6896f3b6&"
import script from "./wenjian.vue?vue&type=script&lang=ts&"
export * from "./wenjian.vue?vue&type=script&lang=ts&"
import style0 from "./wenjian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports